import * as React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Block } from '../Layout/Block'
import { Link } from '../Link'
import { Button } from '../Button'
import { Text } from '../Text'

interface Props {
  className?: string
  url?: string
  title?: string
  simple?: boolean
  buttonLabel: string
  cancelButtonLabel?: string
  onAcceptClick: () => void
  onCancelClick?: () => void
}

const StyledContainer = styled.div`
  position: fixed;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  overflow-y: hidden;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 2;
`
export const StyledPaper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${rem(300)};
  height: auto;
  ${p => p.theme.media.desktop`
    width: ${rem(p.theme.grid.contentMaxWidth.mobile)};
  `};
  background-color: ${p => p.theme.colors.white};
  padding: ${p => rem(p.theme.sizes.small)};
  margin: auto;
  box-shadow: 0 30px 30px ${p => p.theme.colors.darkGrey};
  border-radius: 20px;
`

const StyledActions = styled.div.attrs({})<Props>`
  text-align: center;
  justify-content: center;
`

const StyledText = styled(Text)`
  font-size: 20px;
`

const StyledLink = styled(Link)`
  font-weight: ${p => p.theme.fontWeight.medium};
`

const Actions: React.SFC<Props> = ({ onAcceptClick, simple, buttonLabel, cancelButtonLabel, onCancelClick }) => {
  if (simple) {
    return (
      <Block textAlign="right" marginTop="mini">
        <StyledLink onClick={onAcceptClick}>{buttonLabel}</StyledLink>
      </Block>
    )
  }

  return (
    <Block marginTop="medium" flex justify="end" alignItems="center">
      <Text as="p" marginLeft="mini" marginRight="small">
        <Link onClick={onCancelClick}>{cancelButtonLabel ? cancelButtonLabel : 'Cancelar'}</Link>
      </Text>
      <Button primary onClick={onAcceptClick}>
        {buttonLabel}
      </Button>
    </Block>
  )
}

export const ModalBox: React.SFC<Props> = ({ children, onAcceptClick, title, simple, url, buttonLabel, ...props }) => {
  return (
    <StyledContainer>
      <StyledPaper>
        <Block>
          <StyledText subheader marginBottom="base">
            {title}
          </StyledText>
          {children}
        </Block>
        <StyledActions simple={simple} url={url} onAcceptClick={onAcceptClick} buttonLabel={buttonLabel}>
          <Actions simple={simple} url={url} onAcceptClick={onAcceptClick} buttonLabel={buttonLabel} {...props} />
        </StyledActions>
      </StyledPaper>
    </StyledContainer>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/ModalBox/ModalBox.tsx